import React from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import useModalContext from '@hooks/context/useModalContext';

const ApproveActionModal = () => {
    const { modalData } = useModalContext();
    return (
        <div className={styles.wrapper}>
            <Typography variant="h4" className={styles.title}>
                {modalData?.title}
            </Typography>
            <Typography variant="body2" className={styles.description}>
                {modalData?.description}
            </Typography>
        </div>
    );
};

export default ApproveActionModal;
